/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ValidateEmailCode Input Action
 */
export class ValidateEmailCodeInput implements Msdyn365.IActionInput {
    public emailAddress: string;
    public emailCode: string;
    // TODO: Construct the input needed to run the action
    constructor(emailAddress: string, emailCode: string) {
        this.emailAddress = emailAddress;
        this.emailCode = emailCode;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `DEFAULT + ${this.emailAddress} + ${this.emailCode} ${new Date()}`;
    public getCacheObjectType = () => `IValidateEmailCodeData ${new Date()}`;
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IValidateEmailCodeData {
    validCode: boolean;
    isUserExisting: boolean;
    existingProspect: boolean;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ValidateEmailCodeInput('', '');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: ValidateEmailCodeInput, ctx: Msdyn365.IActionContext): Promise<IValidateEmailCodeData> {
    let result: IValidateEmailCodeData = {
        validCode: false,
        isUserExisting: false,
        existingProspect: false
    };

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecCheckEmailValidationCode`,
        'post',
        {
            checkEmailValidationRequestModel: {
                EmailValidationCode: input.emailCode,
                EmailAddress: input.emailAddress
            }
        },
        { headers: { OUN: ctx.requestContext.apiSettings.oun } }
    ).then(res => {
        result = {
            validCode: (res?.data as any)?.IsCodeValid || false,
            isUserExisting: (res?.data as any)?.ExistingUser || false,
            existingProspect: (res?.data as any)?.ExistingProspect || false
        };
    });

    return {
        validCode: result.validCode,
        isUserExisting: result.isUserExisting,
        existingProspect: result.existingProspect
    };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IValidateEmailCodeData>>action,
    // TODO: Give your data action a unique id
    id: 'TecCheckEmailValidationCode',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
